const c = {
  name: "Emu",
  dimensions: { width: 32, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 32 40" style="enable-background:new 0 0 32 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M25.3,13c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C24.7,11.7,25.3,12.3,25.3,13z"
			/>
		<path class="st0" d="M8,14.2c0.7,0,1.3-0.6,1.3-1.2c0-0.7-0.6-1.2-1.3-1.2c-0.7,0-1.2,0.6-1.2,1.2C6.8,13.7,7.3,14.2,8,14.2z"/>
		<path class="st0" d="M13,22.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C11.8,21.7,12.3,22.2,13,22.2z"
			/>
		<path class="st0" d="M20.3,21c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C19.7,19.7,20.3,20.3,20.3,21z"
			/>
		<path class="st0" d="M15,0v4h2V0h2v4h1c2.4,0,4.4,1.7,4.9,4H32v2h-4c0.4,0.6,0.7,1.3,0.9,2H32v2h-3.1c-0.3,1.6-1.4,2.9-2.9,3.6
			l4.7,4.7l-8.7,4V36h4v2h-4v2h-2V27.3l-4,1.8l-4-1.8V40h-2v-8H6v-2h4v-3.7l-8.7-4L6,17.6c-1.5-0.6-2.6-2-2.9-3.6H0v-2h3.1
			c0.1-0.7,0.5-1.4,0.9-2H0V8h7.1C7.6,5.7,9.6,4,12,4h1V0H15z M22.9,8.1C22.5,6.9,21.4,6,20,6h-8c-1.4,0-2.5,0.9-2.9,2.1
			c2.1,0.5,3.7,2.3,3.9,4.4l3,3l3-3C19.2,10.4,20.8,8.6,22.9,8.1z M24,10c-1.7,0-3,1.3-3,3c0,1.7,1.3,3,3,3c1.7,0,3-1.3,3-3
			C27,11.3,25.7,10,24,10z M8,10c-1.7,0-3,1.3-3,3c0,1.7,1.3,3,3,3c1.7,0,3-1.3,3-3C11,11.3,9.7,10,8,10z M19.4,15L16,18.4L12.6,15
			c-0.7,1.6-2.3,2.8-4.2,3l-3.7,3.7L16,26.9l11.3-5.2L23.6,18C21.7,17.8,20.1,16.6,19.4,15z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Emu
};
